import {useState} from 'react'
import CategoryButton from './CategoryButton'

const ProjectsCategories = ({categories, onFilterProjects}) => {
	const [ativeCategory, setAtiveCategory] = useState("all");

	
	const changeCategoryHandler=(activeCat)=>{
		setAtiveCategory(activeCat);
		onFilterProjects(activeCat);
	}

	return (
		<div className="portfolio__categories" data-aos="fade-up">
			{categories.map(category=>(
				<CategoryButton 
				onChangeCategory={()=>changeCategoryHandler(category)}
				key={category} 
				category={category}
				className={`btn cat__btn ${ativeCategory === category ? "primary": "white"}`}/>
			))}
		</div>
	)
}

export default ProjectsCategories